module.exports = __webpack_public_path__ + "static/img/partner-logo4@3x.f8494f11.png";